import {
    REQUEST_SHIPMENT_PROBLEM,
    REQUEST_SHIPMENT_PROBLEM_FAILURE,
    REQUEST_SHIPMENT_PROBLEM_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";

const initialState = {
    shipmentProblem: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const shipmentProblemReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SHIPMENT_PROBLEM:
            return {
                ...state,
                shipmentProblem: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SHIPMENT_PROBLEM_SUCCESS:
            return {
                ...state,
                shipmentProblem: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SHIPMENT_PROBLEM_FAILURE:
            return {
                ...state,
                shipmentProblem: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
